import { c as _c } from "react/compiler-runtime";
import { StarIcon } from '@heroicons/react/24/solid';
import { useState } from 'react';
import { User } from '@/frontend/design-system/actions/User';
import { LightCard } from '@/frontend/design-system/data-display/Card';
import { H3 } from '@/frontend/design-system/typography/Heading';
import { P2 } from '@/frontend/design-system/typography/Paragraph';
import { cn } from '@/frontend/utils';
export type Review = {
  id: string;
  author: string;
  rating: number;
  content: string;
  title?: string;
  avatarUrl?: string;
};
function StarRating(t0) {
  const $ = _c(3);
  const {
    rating
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [1, 2, 3, 4, 5];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== rating) {
    t2 = <div className="flex gap-1">{t1.map(star => <StarIcon key={star} className={cn("h-6 w-6", star <= rating ? "text-yellow-400" : "text-gray-300")} />)}</div>;
    $[1] = rating;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export function ReviewCard(t0) {
  const $ = _c(30);
  const {
    review
  } = t0;
  const [isExpanded, setIsExpanded] = useState(false);
  const t1 = isExpanded ? "h-auto" : "h-80";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("flex flex-col justify-between gap-4 shadow-sm transition-all duration-300", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== review.rating) {
    t3 = <StarRating rating={review.rating} />;
    $[2] = review.rating;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== review.title) {
    t4 = review.title && <H3>{review.title}</H3>;
    $[4] = review.title;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = !isExpanded && "line-clamp-5";
  let t6;
  if ($[6] !== t5) {
    t6 = cn("text-contentSecondary", t5);
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== review.content || $[9] !== t6) {
    t7 = <P2 className={t6}>{review.content}</P2>;
    $[8] = review.content;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== isExpanded) {
    t8 = !isExpanded && <button type="button" onClick={() => setIsExpanded(true)} className="mt-2 self-start font-medium text-blue-600 text-sm transition-colors hover:text-blue-800">Zobacz całą opinię</button>;
    $[11] = isExpanded;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== isExpanded) {
    t9 = isExpanded && <button type="button" onClick={() => setIsExpanded(false)} className="mt-2 self-start font-medium text-blue-600 text-sm transition-colors hover:text-blue-800">Zwiń opinię</button>;
    $[13] = isExpanded;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t7 || $[16] !== t8 || $[17] !== t9) {
    t10 = <div className="flex flex-col">{t7}{t8}{t9}</div>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t3 || $[21] !== t4) {
    t11 = <div className="space-y-4">{t3}{t4}{t10}</div>;
    $[19] = t10;
    $[20] = t3;
    $[21] = t4;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== review.author || $[24] !== review.avatarUrl) {
    t12 = <User fullname={review.author} src={review.avatarUrl} small={true} />;
    $[23] = review.author;
    $[24] = review.avatarUrl;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t11 || $[27] !== t12 || $[28] !== t2) {
    t13 = <LightCard className={t2}>{t11}{t12}</LightCard>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t2;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
}